(function () {
  if (window.__productReviewsBound) return;
  window.__productReviewsBound = true;

  let scheduled = false;

  function run() {
    document.querySelectorAll("[data-product-reviews]").forEach(enhance);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      run();
    });
  }

  function shapeCard(rev) {
    if (rev.getAttribute("data-shaped") === "true") return;

    const rating = rev.querySelector(".jdgm-rev__rating");
    const title = rev.querySelector(".jdgm-rev__title");
    const body = rev.querySelector(".jdgm-rev__body");
    const author = rev.querySelector(".jdgm-rev__author");
    if (!author) return;

    const name = author.textContent.replace(/\s+/g, " ").trim();
    const initial = name ? name.charAt(0).toUpperCase() : "";
    const footer = document.createElement("div");
    footer.className = "product-reviews__reviewer";

    if (initial) {
      const badge = document.createElement("span");
      badge.className = "product-reviews__avatar";
      badge.setAttribute("aria-hidden", "true");
      badge.textContent = initial;
      footer.appendChild(badge);
    }

    footer.appendChild(author);

    [rating, title, body, footer].forEach(function (node) {
      if (node) rev.appendChild(node);
    });

    rev.querySelectorAll(".jdgm-rev__header, .jdgm-rev__content").forEach(function (el) {
      if (!el.querySelector(".jdgm-rev__rating, .jdgm-rev__title, .jdgm-rev__body, .jdgm-rev__author")) {
        el.classList.add("is-empty");
      }
    });

    rev.setAttribute("data-shaped", "true");
  }

  function enhance(root) {
    const widg = root.querySelector(".jdgm-rev-widg");
    if (!widg) return;

    const summary = widg.querySelector(".jdgm-rev-widg__summary");
    const histogram = widg.querySelector(".jdgm-histogram");
    if (summary && histogram && !summary.contains(histogram)) {
      summary.appendChild(histogram);
    }

    let count = parseInt(widg.getAttribute("data-number-of-reviews"), 10);
    if (isNaN(count)) count = root.querySelectorAll(".jdgm-rev").length;

    const average = parseFloat(widg.getAttribute("data-average-rating"));
    const averageEl = widg.querySelector(".jdgm-rev-widg__summary-average");
    if (averageEl && !isNaN(average)) {
      averageEl.textContent = (Math.round(average * 10) / 10).toFixed(1);
    }

    const summaryText = widg.querySelector(".jdgm-rev-widg__summary-text");
    if (summaryText) {
      summaryText.textContent = "Based on " + count + (count === 1 ? " review" : " reviews");
    }

    widg.querySelectorAll(".jdgm-histogram__row").forEach(function (row) {
      const star = row.querySelector(".jdgm-histogram__star");
      const rating = row.getAttribute("data-rating");
      if (star && rating) star.setAttribute("data-rating", rating);
    });

    root.querySelectorAll(".jdgm-rev").forEach(shapeCard);

    const toggle = root.querySelector("[data-product-reviews-toggle]");
    const visibleCards = root.querySelectorAll(".jdgm-rev").length;
    if (toggle) {
      if (count > 3 || visibleCards > 3) {
        toggle.hidden = false;
        if (root.getAttribute("data-expanded") === "true") {
          root.classList.remove("is-collapsed");
          toggle.textContent = "Show fewer reviews";
          toggle.setAttribute("aria-expanded", "true");
        } else {
          root.classList.add("is-collapsed");
          toggle.textContent = "View all reviews";
          toggle.setAttribute("aria-expanded", "false");
        }
      } else {
        toggle.hidden = true;
        root.classList.remove("is-collapsed");
      }
    }

    root.classList.add("is-ready");
  }

  document.addEventListener("click", function (event) {
    const writeButton = event.target.closest("[data-product-reviews-write-btn]");
    if (writeButton) {
      const writeRoot = writeButton.closest("[data-product-reviews]");
      const writeLink = writeRoot && writeRoot.querySelector(".jdgm-widget .jdgm-write-rev-link");
      if (writeLink) {
        const savedScroll = window.scrollY;
        function keepPlace(linkEvent) {
          linkEvent.preventDefault();
          linkEvent.stopPropagation();
        }
        writeLink.addEventListener("click", keepPlace);
        writeLink.click();
        writeLink.removeEventListener("click", keepPlace);
        if (window.scrollY !== savedScroll) window.scrollTo(0, savedScroll);
      }
      return;
    }

    const button = event.target.closest("[data-product-reviews-toggle]");
    if (!button) return;
    const root = button.closest("[data-product-reviews]");
    if (!root) return;

    const expanded = root.getAttribute("data-expanded") === "true";
    root.setAttribute("data-expanded", expanded ? "false" : "true");
    enhance(root);
  });

  document.addEventListener("jdgm.doneRendering", run);

  let polls = 0;
  const poll = window.setInterval(function () {
    run();
    polls += 1;
    if (polls >= 20) window.clearInterval(poll);
  }, 500);

  function watch() {
    document.querySelectorAll("[data-product-reviews-widget]").forEach(function (slot) {
      if (slot.getAttribute("data-watching") === "true") return;
      slot.setAttribute("data-watching", "true");
      const observer = new MutationObserver(schedule);
      observer.observe(slot, { childList: true, subtree: true });
    });
    schedule();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", watch);
  } else {
    watch();
  }
})();
